import React from 'react';

export default class EmptyView extends React.Component {
   render() {
      return <div></div>;
   }
}
